const calculHeightHeader = () => {
    const topBar = document.querySelector('.top--bar');
    const navDesktop = document.querySelector('.nav-desktop');
    const navMobile = document.querySelector('.nav-mobile');


    let headerHeight = 0;
    let headerHeightSticky = 0;
    let topBarHeight = 0;
    let headerHeightSearch  = 0;
    let headerHeightSearchSticky  = 0;

    if (topBar == null) {
        topBarHeight = 0;
    } else {
        topBarHeight = topBar.offsetHeight;
    }

    if (window.matchMedia("(min-width: 769px)").matches) {
        headerHeight = topBarHeight + navDesktop.offsetHeight;
        headerHeightSticky = navDesktop.offsetHeight;
        headerHeightSearch = topBarHeight + navDesktop.offsetHeight;
        headerHeightSearchSticky = headerHeightSticky;
    } else {
        //sur mobile
        headerHeight = navMobile.offsetHeight + navDesktop.offsetHeight;
        headerHeightSticky = navMobile.offsetHeight;
        headerHeightSearch = navMobile.offsetHeight ;
        headerHeightSearchSticky = navMobile.offsetHeight;
    }
    return [headerHeightSticky, headerHeight, headerHeightSearch, headerHeightSearchSticky];
    
}

export default calculHeightHeader;